import BasketLoves from 'components/Basket/BasketLoves/BasketLoves';
import withBasketLovesProps from 'viewModel/basket/basketLoves/withBasketLovesProps';

export default withBasketLovesProps(BasketLoves);
